const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
const currencyFormatter = (amount) => formatter.format(amount);

const formatPhoneNumber = (phoneNumberString) => {
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  }
  return null;
};

const getAssetURL = (fileName) =>
  `${process.env.REACT_APP_ASSET_URL}${fileName}`;

const siteVersion = process.env.REACT_APP_BASENAME.includes("fss");
const getMetaDescription = (loan) =>
  `I am proud to announce my financial success has been reviewed by Sun West, a major national lender, and I have been awarded a certificate for ${currencyFormatter(
    loan?.purchasePrice
  )
    .split(".")
    .shift()}. With this, I can buy a ${currencyFormatter(loan?.purchasePrice)
    .split(".")
    .shift()} house with the same strength as a cash buyer.`;
module.exports = {
  getMetaDescription,
  currencyFormatter,
  siteVersion,
  getAssetURL,
  formatPhoneNumber,
};
